import { PILLARS } from "../data/pillars";
import { MockPanel } from "./MockPanel";

const PillarText = ({ pillar }) => (
    <div className={pillar._flipped ? "lg:order-2" : ""}>
        <span className="inline-flex items-center gap-2.5 font-mono text-xs tracking-[0.04em] text-neon">
            <span className="text-black/40">{pillar.num}</span>
            <span className="w-6 h-px bg-neon/50" />
            {pillar.tag}
        </span>

        <h3 className="font-mono tracking-[-0.01em] text-2xl sm:text-3xl font-semibold text-black mt-4 leading-snug">
            {pillar.headline}
        </h3>

        <ul className="mt-6 space-y-4">
            {pillar.bullets.map((b) => (
                <li key={b.lead} className="flex gap-3.5">
                    <span className="mt-2 shrink-0 w-1.5 h-1.5 rounded-full bg-black group-hover:bg-neon transition-colors" />
                    <p className="font-body text-base text-black/65 leading-relaxed">
                        <span className="font-semibold text-black">
                            {b.lead}
                        </span>{" "}
                        {b.desc}
                    </p>
                </li>
            ))}
        </ul>
    </div>
);

const PillarItem = ({ pillar, index }) => {
    const flipped = index % 2 === 1;
    return (
        <div
            id={pillar.id}
            data-testid={`pillar-card-${pillar.id}`}
            className="group grid lg:grid-cols-2 gap-8 lg:gap-14 items-center scroll-mt-28"
        >
            <PillarText pillar={{ ...pillar, _flipped: flipped }} />
            <div className={flipped ? "lg:order-1" : ""}>
                <MockPanel pillar={pillar} />
            </div>
        </div>
    );
};

export const Pillars = () => (
    <section
        id="services"
        data-testid="pillars-section"
        className="relative py-24 sm:py-32"
    >
        <div className="max-w-6xl mx-auto px-5 sm:px-8">
            <div className="max-w-2xl mb-16 sm:mb-24">
                <span className="font-mono text-xs tracking-[-0.01em] text-black/50">
                    // THE KEY PILLARS
                </span>
                <h2 className="font-mono tracking-[-0.01em] text-3xl sm:text-4xl font-semibold text-black mt-3">
                    Five engines. One operation.
                </h2>
                <p className="font-body text-base sm:text-lg text-black/60 mt-4">
                    Areas where tailored AI and optimisation boost efficiency —
                    deployed pillar by pillar across your business.
                </p>
            </div>

            <div className="space-y-16 sm:space-y-24">
                {PILLARS.map((p, i) => (
                    <PillarItem key={p.id} pillar={p} index={i} />
                ))}
            </div>
        </div>
    </section>
);
